import { gql } from '@apollo/client'

import { PRIORITY_TASK_FRAGMENT } from '../fragments'

const ACTIVE_PRIORITY_TASKS_QUERY = gql`
  query activePriorityTasksQuery {
    activePriorityTasks {
      ...PriorityTaskFragment
    }
  }
  ${PRIORITY_TASK_FRAGMENT}
`

export default ACTIVE_PRIORITY_TASKS_QUERY
